module.exports = {"id":"212791","name":"Kim Seung Dae","rating":"71","photo":"./data/images/photos/0/212791.png","club":{"name":"Pohang Steelers","logo":"./data/images/clubs/PohangSteelers.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KimSeungDae0.json
// module id = 2382
// module chunks = 0